module.exports = "/static/assets/a998ad61ffc51ecd25cad7ef43a2d9f5.png";